import React from "react";

export const ListLabel = ({ label }) => {
  return (
    <div className="tw-rounded-md tw-bg-[linear-gradient(125deg,#dfdbfd_9.9%,#f1effe_45.45%,#dfdbfd_81.01%)] tw-text-[#291a93] tw-text-sm tw-leading-normal tw-tracking-[0.28px] tw-py-[6.25px] tw-px-[10px]">
      {label}
    </div>
  );
};
